<template>
  <div class="flex min-h-screen flex-col bg-blue-lighter">
    <Header hideLogo class="hidden lg:flex" />
    <main class="flex grow flex-col bg-white pb-20 lg:pb-0">
      <slot></slot>
    </main>
    <NavBarMobile />
  </div>
</template>
